import clsx from 'clsx'
import { BannerCard, Logo, TitlePage } from 'components/atoms'
import React, { LegacyRef, RefObject, useContext, useEffect, useRef, useState } from 'react'
import './BannerMenu.css'
import useMediaQuery from 'hook/useMediaQuery'
import { MediaMobile, MediaTablet } from 'api/const/MediaQuery'
import useIntersection from 'hook/useIntersection'
import { Service } from 'components/pagine'
import { getServicesBanner } from 'api/Api'
import { useNavigate } from 'react-router-dom'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'

export const  BannerMenu = () => {
  const[isHover, setIsHover] = useState<boolean>(false)
  const mobile = useMediaQuery(MediaTablet)
  const linkRef = useRef<HTMLDivElement | null>(null)
  const inViewport = useIntersection(linkRef, '800px');
  const navigate = useNavigate()
  const { baseUri,setErrorModal, bannerList, getBannerList } = useContext(AppGeneralContext)


  useEffect(()=>{
    getBannerList()
  },[])

  


  useEffect(()=>{

    if(!mobile){
      return
    }
    setIsHover(inViewport.isVisible)
  
  },[mobile,inViewport])

  return (<>
{ bannerList.length !== 0 ? 
  <>
 <TitlePage as="h3" className='font-weight-bold mt-5' title='Featured Services' />
<div className="mt-3 d-flex flex-row justify-content-between w-100 align-items-center  flex-wrap ">
      <div className={clsx('d-flex flex-row flex-wrap  ',
      {"w-100 justify-content-center " :mobile},
      {"col-xl-9 col-lg-8 col-md-7 col-7 justify-content-start border-end border-end-solid":!mobile})} >
        { (bannerList && bannerList.length !== 0 ) &&   bannerList.map((x,i)=>{
         return <BannerCard  key={x.id} 
         image={x.logoUrl ? baseUri + x.logoUrl : ""}
          title={x.title ?? ""} 
          description={x.shortDescription}
          onClick={()=>{
           navigate(`/start-up/profile/services/${x.id}/${true}`)
         }}/>
         })
        }
      </div>
        <div  className={clsx(' pointer ',{ "w-100 d-flex align-items-center" :mobile}, {"col-3 ps-2":!mobile})} 
        onMouseEnter={()=>{setIsHover(true)}}  
        onMouseLeave={()=>setIsHover(false)}
        onClick={()=> navigate(`/start-up/profile/services`)}>
      <div ref={linkRef}  className={clsx('d-flex ug flex-row align-items-center w-100   pointer ',
      {"start-anim h-100 justify-content-start ":!isHover && !mobile},
      {"end-anim h-100 justify-content-start ":isHover && !mobile},
      {"h-50 start-anim justify-content-center mt-4": !isHover && mobile},
      {"h-50 end-anim justify-content-center mt-4": isHover && mobile})} >
         <Logo colorLogo='var(--primary)' className={clsx("",
         {"start-logo-anim w-100" : !isHover },
         {"end-logo-anim w-100" : isHover}  )} />
        <span className={clsx('p-0 m-0 ms-1',
         {"start-text-anim": !isHover},
         {"end-text-anim fw-bold":isHover})}> Show More</span>
      </div>
      </div>
    </div> 
    </>
    :null
    }
</>  

  )
}
